module.exports = __webpack_public_path__ + "static/media/Left_Arrow_New.945c6ea0.svg";